<div class="comp-main">
  <div class="center">
    @if (customerEntranceFlagEnabled()) {
      <div class="content-wrapper">
        <div class="input-wrapper">
          <h1 class="input-wrapper__headline">Erhvervsportal</h1>
          <div class="typeahead-wrapper">
            <adm-org-typeahead (itemSelected)="openCustomerEntranceOverlay($event)" />
          </div>
        </div>
      </div>
    }
    <img src="assets/img/public-chargers.jpg" class="image" alt="Elbil der lader på en ladestander" />
  </div>
</div>
